// Makes a UI element to show a status. Status is mapped to a bucket via
// TaskBuckets.taskStatusToBadge — that helper still returns Bootstrap-4-era
// class names (`badge-danger` etc.) for backward compatibility, so we map
// those to Bootstrap 5 / react-bootstrap variants here.

import Badge from 'react-bootstrap/Badge';
import * as TaskBuckets from '../fleet-shared/TaskBuckets.mjs';

const STYLE_TO_BG = {
  'badge-danger':    'danger',
  'badge-warning':   'warning',
  'badge-primary':   'primary',
  'badge-success':   'success',
  'badge-info':      'info',
  'badge-secondary': 'secondary',
};

const StatusBadge = ({ status }) => {
  const cleanStatus = status ? status : '';
  const mapping = TaskBuckets.taskStatusToBadge(cleanStatus) || {};
  const legacyStyle = mapping.style || 'badge-primary';
  const name = mapping.name || '?';
  const bg = STYLE_TO_BG[legacyStyle] || 'primary';

  // The legacy class name stays on the rendered element so existing tests
  // and CSS selectors continue to match.
  return (
    <Badge bg={bg} pill className={legacyStyle}>
      {name}
    </Badge>
  );
};

export default StatusBadge;
